// import { Form, Formik } from "formik";
// import Link from "next/link";
// import { useParams, useRouter } from "next/navigation";
// import { useEffect, useRef, useState } from "react";
// import * as Yup from "yup";
// import axiosProvider from "../../../lib/AxiosProvider";
// import { spaceToDash } from "../../../lib/GetBaseUrl";
// import useDebounce from "../../../lib/useDebounce";

// const ProductSearchBar = ({ placeholder }) => {
//   const router = useRouter();
//   const params = useParams();
//   const profileRef = useRef(null);
//   const [searchText, setSearchText] = useState();
//   const debounceSearchText = useDebounce(searchText, 500);
//   const [suggestions, setSuggestions] = useState(false);
//   const validationSchema = Yup.object().shape({
//     searchTexts: Yup.string().required(),
//   });

//   const handleSearch = async (values) => {
//     setSuggestions(false);
//     document.activeElement.blur();
//     router.push(`/products/search/${spaceToDash(values?.searchTexts)}`);
//   };

//   const fetchData = async (endpoint, setterFunc) => {
//     const response = await axiosProvider({
//       method: "GET",
//       endpoint,
//     });
//     if (response?.data?.code === 200) {
//       return setterFunc(response);
//     } else {
//       setSuggestions(false);
//     }
//   };
//   useEffect(() => {
//     if (searchText) {
//       fetchData(
//         `user/Product/searchsuggestion?searchText=${debounceSearchText}`,
//         (resp) => {
//           setSuggestions(resp?.data?.data);
//         }
//       );
//     }
//   }, [debounceSearchText]);

//   useEffect(() => {
//     setSuggestions(false);
//   }, [params]);

//   useEffect(() => {
//     const handleOutsideClick = (event) => {
//       if (profileRef.current && !profileRef.current.contains(event.target)) {
//         setSuggestions(false);
//       }
//     };

//     document.body.addEventListener("click", handleOutsideClick);
//     return () => {
//       document.body.removeEventListener("click", handleOutsideClick);
//     };
//   }, []);

//   return (
//     <div className="search_container" ref={profileRef}>
//       <Formik
//         enableReinitialize={true}
//         initialValues={{
//           searchTexts: "",
//         }}
//         validationSchema={validationSchema}
//         onSubmit={handleSearch}
//       >
//         {({ values, setFieldValue }) => (
//           <Form className="search_form">
//             <input
//               id="product-searchbar"
//               autoComplete="off"
//               type="search"
//               placeholder={placeholder}
//               name={"searchTexts"}
//               value={decodeURIComponent(values?.searchTexts) ?? ""}
//               onChange={(e) => {
//                 setFieldValue("searchTexts", e?.target?.value?.trimStart());
//                 if (e?.target?.value?.trim()?.length >= 2) {
//                   setSearchText(e?.target?.value);
//                 } else {
//                   setSuggestions(false);
//                 }
//               }}
//               onBlur={(e) =>
//                 setFieldValue("searchTexts", e?.target?.value?.trim())
//               }
//               onKeyDown={(e) => {
//                 if (e.key === "Enter") {
//                   setSuggestions(false);
//                   setSearchText(false);
//                 }
//               }}
//               // onKeyDown={(e) => handleKeyboardNavigation(e)}
//               className="search_textbox"
//             />
//             <button type="submit" className="search_submit">
//               <i className="m-icon m-search-icon"></i>
//             </button>

//             {(suggestions?.categories?.length > 0 ||
//               suggestions?.brands?.length > 0 ||
//               suggestions?.products?.length > 0) && (
//               <div className="suggestions_container">
//                 <div className="p_indide">
//                   {suggestions?.categories?.length > 0 && (
//                     <ul className="suggestions_list">
//                       <li className="static_title">Categories</li>
//                       {suggestions?.categories?.map((categories, index) => (
//                         <li
//                           key={index}
//                           // className={
//                           //   index === highlightedResultIndex
//                           //     ? 'selected'
//                           //     : 'suggestion_item'
//                           // }
//                           className="suggestion_item"
//                         >
//                           <Link
//                             href={`/products/search/${spaceToDash(
//                               categories?.name
//                             )}`}
//                             onClick={() => {
//                               setSuggestions(false);
//                               setFieldValue("searchTexts", "");
//                             }}
//                           >
//                             {categories?.name}
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                   {suggestions?.brands?.length > 0 && (
//                     <ul className="suggestions_list">
//                       <li className="static_title">Brands</li>
//                       {suggestions?.brands?.map((brand, index) => (
//                         <li
//                           key={index}
//                           // className={
//                           //   index === highlightedResultIndex
//                           //     ? 'selected'
//                           //     : 'suggestion_item'
//                           // }
//                           className="suggestion_item"
//                         >
//                           <Link
//                             href={`/products/search/${spaceToDash(
//                               brand?.name
//                             )}`}
//                             onClick={() => {
//                               setSuggestions(false);
//                               setFieldValue("searchTexts", "");
//                             }}
//                           >
//                             {brand?.name}
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                   {suggestions?.products?.length > 0 && (
//                     <ul className="suggestions_list">
//                       <li className="static_title">Products</li>
//                       {suggestions?.products?.map((product, index) => (
//                         <li
//                           key={index}
//                           // className={
//                           //   index === highlightedResultIndex
//                           //     ? 'selected'
//                           //     : 'suggestion_item'
//                           // }
//                           className="suggestion_item"
//                         >
//                           <Link
//                             href={`/products/search/${spaceToDash(
//                               product?.productName
//                             )}`}
//                             onClick={() => {
//                               setSuggestions(false);
//                               setFieldValue("searchTexts", "");
//                             }}
//                           >
//                             {product?.productName}
//                           </Link>
//                         </li>
//                       ))}
//                     </ul>
//                   )}
//                 </div>
//               </div>
//             )}
//           </Form>
//         )}
//       </Formik>
//     </div>
//   );
// };

// export default ProductSearchBar;
'use client'

import { Form, Formik } from 'formik'
import Link from 'next/link'
import { useParams, useRouter } from 'next/navigation'
import { useEffect, useRef, useState } from 'react'
import * as Yup from 'yup'
import axiosProvider from '../../../lib/AxiosProvider'
import {
  encodeURIForName,
  reactImageUrl,
  spaceToDash
} from '../../../lib/GetBaseUrl'
import useDebounce from '../../../lib/useDebounce'
import Image from 'next/image'
import { _brandImg_, _categoryImg_, _productImg_ } from '@/lib/ImagePath'
import { pixelTrack } from '@/lib/metaPixel'
import { gaEvent } from '@/lib/ga'

const ProductSearchBar = ({ placeholder, onCancelSearch }) => {
  const router = useRouter()
  const params = useParams()
  const profileRef = useRef(null)
  const [searchText, setSearchText] = useState('')
  const debounceSearchText = useDebounce(searchText, 500)
  const [suggestions, setSuggestions] = useState(false)
  const [highlightedIndex, setHighlightedIndex] = useState(-1)
  const [flatSuggestions, setFlatSuggestions] = useState([])

  const validationSchema = Yup.object().shape({
    searchTexts: Yup.string().required()
  })

  const handleSearch = async (values, { resetForm, setFieldValue }) => {
    setSuggestions(false)
    document.activeElement.blur()
    pixelTrack('Search', { search_string: values?.searchTexts })
    gaEvent('search', { search_term: values?.searchTexts })
    router.push(`/products/search/${encodeURIForName(values?.searchTexts)}`)
    resetForm()
  }

  const fetchData = async (endpoint, setterFunc) => {
    const response = await axiosProvider({
      method: 'GET',
      endpoint
    })
    if (response?.data?.code === 200) {
      return setterFunc(response)
    } else {
      setSuggestions(false)
      setSearchText('')
    }
  }

  useEffect(() => {
    if (searchText) {
      fetchData(
        `user/Product/searchsuggestion?searchText=${debounceSearchText}`,
        (resp) => {
          setSuggestions(resp?.data?.data)
        }
      )
    }
  }, [debounceSearchText])

  useEffect(() => {
    setSuggestions(false)
  }, [params])

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setSuggestions(false)
      }
    }

    document.body.addEventListener('click', handleOutsideClick)
    return () => {
      document.body.removeEventListener('click', handleOutsideClick)
    }
  }, [])

  useEffect(() => {
    if (suggestions) {
      const all = []

      suggestions?.categories?.forEach((item) =>
        all.push({ ...item, type: 'category' })
      )
      suggestions?.brands?.forEach((item) =>
        all.push({ ...item, type: 'brand' })
      )
      suggestions?.products?.forEach((item) =>
        all.push({ ...item, type: 'product' })
      )

      setFlatSuggestions(all)
      setHighlightedIndex(all.length > 0 ? 0 : -1)
    }
  }, [suggestions])

  const handleKeyboardNavigation = (e) => {
    if (!flatSuggestions.length) return

    if (e.key === 'ArrowDown') {
      e.preventDefault()
      setHighlightedIndex((prev) =>
        prev < flatSuggestions.length - 1 ? prev + 1 : 0
      )
    } else if (e.key === 'ArrowUp') {
      e.preventDefault()
      setHighlightedIndex((prev) =>
        prev > 0 ? prev - 1 : flatSuggestions.length - 1
      )
    } else if (e.key === 'Enter') {
      e.preventDefault()
      const selected = flatSuggestions[highlightedIndex]
      if (!selected) return

      setSuggestions(false)
      if (selected.type === 'category') {
        router.push(`/products/search/${spaceToDash(selected?.name)}`)
      } else if (selected.type === 'brand') {
        router.push(`/products/search/${spaceToDash(selected?.name)}`)
      } else if (selected.type === 'product') {
        router.push(
          `/product/${encodeURIForName(
            selected?.customeProductName ?? selected?.productName
          )}?productGuid=${selected?.guid}`
        )
      }
    } else if (e.key === 'Escape') {
      setSuggestions(false)
    }
  }

  useEffect(() => {
    const handleCtrlSFocus = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 's') {
        e.preventDefault() // stop browser “Save Page”
        const searchInput = document.getElementById('product-searchbar')
        if (searchInput) {
          searchInput.focus()
          searchInput.select()
        }
      }
    }

    window.addEventListener('keydown', handleCtrlSFocus)
    return () => window.removeEventListener('keydown', handleCtrlSFocus)
  }, [])

  // const [currentSuggestionType, setCurrentSuggestionType] = useState('')

  // const handleKeyboardNavigation = (e) => {
  //   const suggestionTypes = ['categories', 'brands', 'products']
  //   let currentIndex = suggestionTypes.findIndex(
  //     (type) => type === currentSuggestionType
  //   )

  //   // Check if any suggestions are available for the current suggestion type
  //   if (
  //     !suggestions[currentSuggestionType] ||
  //     suggestions[currentSuggestionType].length === 0
  //   ) {
  //     // Move to the next suggestion type
  //     currentIndex = (currentIndex + 1) % suggestionTypes.length
  //     setCurrentSuggestionType(suggestionTypes[currentIndex])
  //     return
  //   }

  //   switch (e.key) {
  //     case 'ArrowUp':
  //       e.preventDefault()
  //       setHighlightedResultIndex((prevIndex) => Math.max(prevIndex - 1, 0))
  //       break
  //     case 'ArrowDown':
  //       e.preventDefault()
  //       setHighlightedResultIndex((prevIndex) =>
  //         Math.min(prevIndex + 1, suggestions[currentSuggestionType].length - 1)
  //       )
  //       break
  //     case 'Enter':
  //       e.preventDefault()
  //       if (highlightedResultIndex !== -1) {
  //         const selectedSuggestion =
  //           suggestions[currentSuggestionType][highlightedResultIndex]
  //         if (selectedSuggestion) {
  //           router.push(
  //             `/products/search/${spaceToDash(selectedSuggestion.name)}`
  //           )
  //           setSearchText('')
  //           setSuggestions(null)
  //         }
  //       }
  //       break
  //     default:
  //       break
  //   }

  //   // Check if the current suggestion is the last one
  //   if (
  //     highlightedResultIndex ===
  //       suggestions[currentSuggestionType].length - 1 &&
  //     currentIndex !== suggestionTypes.length - 1
  //   ) {
  //     // Move to the next suggestion type
  //     currentIndex = (currentIndex + 1) % suggestionTypes.length
  //     setCurrentSuggestionType(suggestionTypes[currentIndex])
  //   }
  // }

  // const [highlightedResultIndex, setHighlightedResultIndex] = useState(-1)

  return (
    // <div className="search_container" ref={profileRef}>
    //   <Formik
    //     enableReinitialize={true}
    //     initialValues={{
    //       searchTexts: ''
    //     }}
    //     validationSchema={validationSchema}
    //     onSubmit={(values, formikHelpers) =>
    //       handleSearch(values, formikHelpers)
    //     }
    //   >
    //     {({ values, setFieldValue }) => (
    //       <Form className="search_form">
    //         <input
    //           id="product-searchbar"
    //           autoComplete="off"
    //           type="search"
    //           placeholder={placeholder}
    //           name={'searchTexts'}
    //           value={decodeURIComponent(values?.searchTexts) ?? ''}
    //           onChange={(e) => {
    //             setFieldValue('searchTexts', e?.target?.value?.trimStart())
    //             if (e?.target?.value?.trim()?.length >= 2) {
    //               setSearchText(e?.target?.value)
    //             } else {
    //               setSuggestions(false)
    //               setSearchText('')
    //             }
    //           }}
    //           onBlur={(e) =>
    //             setFieldValue('searchTexts', e?.target?.value?.trim())
    //           }
    //           onKeyDown={handleKeyboardNavigation}
    //           className="search_textbox"
    //         />

    //         <button type="submit" className="search_submit" aria-label="Search">
    //           <i className="m-icon m-search-icon"></i>
    //         </button>

    //         {(suggestions?.categories?.length > 0 ||
    //           suggestions?.brands?.length > 0 ||
    //           suggestions?.products?.length > 0) && (
    //           <div className="suggestions_container">
    //             <div className="p_indide">
    //               {/* Categories */}
    //               {suggestions?.categories?.length > 0 && (
    //                 <ul className="suggestions_list grid sm:grid-cols-2 gap-2">
    //                   <li className="static_title sm:col-span-2 font-medium text-TextTitle py-1 px-4 bg-[#eaeaec] -mx-4">
    //                     Categories
    //                   </li>
    //                   {suggestions?.categories?.map((categories, index) => {
    //                     const flatIndex = flatSuggestions.findIndex(
    //                       (f) =>
    //                         f?.name === categories?.name &&
    //                         f?.type === 'category'
    //                     )
    //                     const isActive = flatIndex === highlightedIndex
    //                     return (
    //                       <li
    //                         key={index}
    //                         className={`suggestion_item ${
    //                           isActive ? 'bg-gray-100' : ''
    //                         } p-2 rounded-md hover:bg-gray-100 transition-all ease-in-out duration-300`}
    //                       >
    //                         <Link
    //                           href={`/products/search/${spaceToDash(
    //                             categories?.name
    //                           )}`}
    //                           onClick={() => setSuggestions(false)}
    //                           className="flex items-center gap-2 text-sm"
    //                         >
    //                           <Image
    //                             src={`${reactImageUrl}${_categoryImg_}${categories?.image}`}
    //                             alt={categories?.image}
    //                             width={40}
    //                             height={40}
    //                             className="h-10"
    //                           />
    //                           {categories?.name}
    //                         </Link>
    //                       </li>
    //                     )
    //                   })}
    //                 </ul>
    //               )}

    //               {/* Brands */}
    //               {suggestions?.brands?.length > 0 && (
    //                 <ul className="suggestions_list grid sm:grid-cols-2 gap-2">
    //                   <li className="static_title sm:col-span-2 font-medium text-TextTitle py-1 px-4 bg-[#eaeaec] -mx-4">
    //                     Brands
    //                   </li>
    //                   {suggestions?.brands?.map((brand, index) => {
    //                     const flatIndex = flatSuggestions.findIndex(
    //                       (f) => f?.name === brand?.name && f?.type === 'brand'
    //                     )
    //                     const isActive = flatIndex === highlightedIndex
    //                     return (
    //                       <li
    //                         key={index}
    //                         className={`suggestion_item ${
    //                           isActive ? 'bg-gray-100' : ''
    //                         } p-2 rounded-md hover:bg-gray-100 transition-all ease-in-out duration-300`}
    //                       >
    //                         <Link
    //                           href={`/products/search/${spaceToDash(
    //                             brand?.name
    //                           )}`}
    //                           onClick={() => setSuggestions(false)}
    //                           className="flex items-center gap-2 text-sm"
    //                         >
    //                           <Image
    //                             src={`${reactImageUrl}${_brandImg_}${brand?.logo}`}
    //                             alt={brand?.logo}
    //                             width={40}
    //                             height={40}
    //                             className="h-10"
    //                           />
    //                           {brand?.name}
    //                         </Link>
    //                       </li>
    //                     )
    //                   })}
    //                 </ul>
    //               )}

    //               {/* Products */}
    //               {suggestions?.products?.length > 0 && (
    //                 <ul className="suggestions_list grid gap-2">
    //                   <li className="static_title font-medium text-TextTitle py-1 px-4 bg-[#eaeaec] -mx-4">
    //                     Products
    //                   </li>
    //                   {suggestions?.products?.map((product, index) => {
    //                     const flatIndex = flatSuggestions.findIndex(
    //                       (f) =>
    //                         f?.guid === product?.guid && f?.type === 'product'
    //                     )
    //                     const isActive = flatIndex === highlightedIndex
    //                     return (
    //                       <li
    //                         key={index}
    //                         className={`suggestion_item ${
    //                           isActive ? 'bg-gray-100' : ''
    //                         } p-2 rounded-md hover:bg-gray-100 transition-all ease-in-out duration-300`}
    //                       >
    //                         <Link
    //                           href={`/product/${encodeURIForName(
    //                             product?.customeProductName ??
    //                               product?.productName
    //                           )}?productGuid=${product?.guid}`}
    //                           onClick={() => setSuggestions(false)}
    //                           className="flex items-center gap-3 text-sm"
    //                         >
    //                           <Image
    //                             src={encodeURI(
    //                               `${reactImageUrl}${_productImg_}${product?.image1}`
    //                             )}
    //                             alt={product?.productName}
    //                             width={40}
    //                             height={40}
    //                             className="h-10"
    //                           />
    //                           {product?.customeProductName ??
    //                             product?.productName}
    //                         </Link>
    //                       </li>
    //                     )
    //                   })}
    //                 </ul>
    //               )}
    //             </div>
    //           </div>
    //         )}
    //       </Form>
    //     )}
    //   </Formik>
    // </div>

    <div className="max-w-full lg:max-w-[88%] xl:max-w-[86rem] mx-auto max-xl:px-4">
      <div className="flex justify-between items-center mb-4 sm:mb-8">
        <h2 className="text-2xl sm:text-4xl">Search</h2>
        <button onClick={onCancelSearch}>
          <i className="m-icon close-icon bg-black aspect-square w-8 h-8"></i>
        </button>
      </div>
      <div className="search_container" ref={profileRef}>
        <Formik
          enableReinitialize={true}
          initialValues={{
            searchTexts: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, formikHelpers) =>
            handleSearch(values, formikHelpers)
          }
        >
          {({ values, setFieldValue }) => (
            <Form className="search_form">
              <input
                id="product-searchbar"
                autoFocus
                autoComplete="off"
                type="search"
                placeholder={placeholder}
                name={"searchTexts"}
                value={decodeURIComponent(values?.searchTexts) ?? ""}
                onChange={(e) => {
                  setFieldValue("searchTexts", e?.target?.value?.trimStart());
                  if (e?.target?.value?.trim()?.length >= 2) {
                    setSearchText(e?.target?.value);
                  } else {
                    setSuggestions(false);
                    setSearchText("");
                  }
                }}
                onBlur={(e) =>
                  setFieldValue("searchTexts", e?.target?.value?.trim())
                }
                onKeyDown={handleKeyboardNavigation}
                className="search_textbox"
              />

              <button
                type="submit"
                className="search_submit"
                aria-label="Search"
              >
                <i className="m-icon m-search-icon"></i>
              </button>

              {(suggestions?.categories?.length > 0 ||
                suggestions?.brands?.length > 0 ||
                suggestions?.products?.length > 0) && (
                <div className="suggestions_container">
                  <div className="p_indide">
                    {/* Categories */}
                    {suggestions?.categories?.length > 0 && (
                      <ul className="suggestions_list grid sm:grid-cols-2 gap-2">
                        <li className="static_title sm:col-span-2 font-medium text-TextTitle py-1 px-4 bg-[#eaeaec] -mx-4">
                          Categories
                        </li>
                        {suggestions?.categories?.map((categories, index) => {
                          const flatIndex = flatSuggestions.findIndex(
                            (f) =>
                              f?.name === categories?.name &&
                              f?.type === "category",
                          );
                          const isActive = flatIndex === highlightedIndex;
                          return (
                            <li
                              key={index}
                              className={`suggestion_item ${
                                isActive ? "bg-gray-100" : ""
                              } p-2 rounded-md hover:bg-gray-100 transition-all ease-in-out duration-300`}
                            >
                              <Link
                                href={`/products/search/${spaceToDash(
                                  categories?.name,
                                )}`}
                                onClick={() => {
                                  setSuggestions(false);
                                  onCancelSearch?.();
                                }}
                                className="flex items-center gap-2 text-sm"
                              >
                                <Image
                                  src={`${reactImageUrl}${_categoryImg_}${categories?.image}`}
                                  alt={categories?.image}
                                  width={40}
                                  height={40}
                                  quality={100}
                                  className="h-10"
                                />
                                {categories?.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}

                    {/* Brands */}
                    {suggestions?.brands?.length > 0 && (
                      <ul className="suggestions_list grid sm:grid-cols-2 gap-2">
                        <li className="static_title sm:col-span-2 font-medium text-TextTitle py-1 px-4 bg-[#eaeaec] -mx-4">
                          Brands
                        </li>
                        {suggestions?.brands?.map((brand, index) => {
                          const flatIndex = flatSuggestions.findIndex(
                            (f) =>
                              f?.name === brand?.name && f?.type === "brand",
                          );
                          const isActive = flatIndex === highlightedIndex;
                          return (
                            <li
                              key={index}
                              className={`suggestion_item ${
                                isActive ? "bg-gray-100" : ""
                              } p-2 rounded-md hover:bg-gray-100 transition-all ease-in-out duration-300`}
                            >
                              <Link
                                href={`/products/search/${spaceToDash(
                                  brand?.name,
                                )}`}
                                onClick={() => {
                                  setSuggestions(false);
                                  onCancelSearch?.();
                                }}
                                className="flex items-center gap-2 text-sm"
                              >
                                <Image
                                  src={`${reactImageUrl}${_brandImg_}${brand?.logo}`}
                                  alt={brand?.logo}
                                  width={40}
                                  height={40}
                                  quality={100}
                                  className="h-10"
                                />
                                {brand?.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}

                    {/* Products */}
                    {suggestions?.products?.length > 0 && (
                      <ul className="suggestions_list grid gap-2">
                        <li className="static_title font-medium text-TextTitle py-1 px-4 bg-[#eaeaec] -mx-4">
                          Products
                        </li>
                        {suggestions?.products?.map((product, index) => {
                          const flatIndex = flatSuggestions.findIndex(
                            (f) =>
                              f?.guid === product?.guid &&
                              f?.type === "product",
                          );
                          const isActive = flatIndex === highlightedIndex;
                          return (
                            <li
                              key={index}
                              className={`suggestion_item ${
                                isActive ? "bg-gray-100" : ""
                              } p-2 rounded-md hover:bg-gray-100 transition-all ease-in-out duration-300`}
                            >
                              <Link
                                href={`/product/${encodeURIForName(
                                  product?.customeProductName ??
                                    product?.productName,
                                )}?productGuid=${product?.guid}`}
                                onClick={() => {
                                  setSuggestions(false);
                                  onCancelSearch?.();
                                }}
                                className="flex items-center gap-3 text-sm"
                              >
                                <Image
                                  src={encodeURI(
                                    `${reactImageUrl}${_productImg_}${product?.image1}`,
                                  )}
                                  alt={product?.productName}
                                  width={40}
                                  height={40}
                                  quality={100}
                                  className="h-10"
                                />
                                {product?.customeProductName ??
                                  product?.productName}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </div>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default ProductSearchBar
